import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { signal } from "@preact/signals-react";

import Divider from "components/MeForm/Divider";
import StdButton from "components/Buttons/StdButton";
import QuickTable from "components/Meta/QuickTable";
import TableData from "./TableData";
import purchaseRequisition from "./ModelPurchaseRequisition";
import FilterParams from "./Filter";
import proxy from "api/proxy";
import useMainStore from "store/mainStore";
import Dialog from "componentsv2/modal/Dialog";

const customQuery = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const modalAttrs = signal({
  type: "warning",
  msg: "",
});
const openModal = signal(false);

function PurchaseRequisition(props) {
  const { config } = props;
  const [type, setType] = useState("requisition");
  const [viewTable, setViewTable] = useState(false);
  const [viewTable2, setViewTable2] = useState(false);
  const [domain, setDomain] = useState([]);
  const [params, setParams] = useState({});
  const [ctxView, setCtxView] = useState(purchaseRequisition(config));
  const { setContext } = useMainStore();

  const [dataRows, setDataRows] = useState([]);
  const [header, setHeader] = useState([]);

  function handleButtonType(e, name) {
    setType(name);
    resetForm();
  }

  function resetForm() {
    setDomain([]);
    setViewTable(false);
    setViewTable2(false);
    setParams({});
    setDataRows([]);
    setHeader([]);
  }

  async function handleFilter(params) {
    // const args = params;
    let viewTable2 = false;
    let domain = [];
    setParams(params);
    if (params.file_upload) {
      const response = await proxy.method({
        model: "dash.app.purchase_requisition",
        method: "process_file",
        args: params,
      });
      if (response.status === "success") {
        const request_ids = response.requests;
        const not_request = response.not_request;
        domain = [
          ["state", "=", "draft"],
          ["id", "in", request_ids],
        ];
        viewTable2 = true;
        setDataRows(not_request.data);
        setHeader(not_request.columns);
        // handleField("requests", request_ids);
      }
    } else {
      if (!params.warehouse) {
        domain.push(["id", "=", -1]);
      } else {
        domain = [
          ["state", "=", "draft"],
          ["warehouse", "=", params.warehouse],
        ];
        const mapping = {
          supplier: "party",
          brand: "product.brand",
          rotation: "product.rotation",
          to_purchase: "to_purchase",
        };

        for (const key in mapping) {
          if (params[key]) {
            domain.push([mapping[key], "=", params[key]]);
          }
        }

        if (params.product) {
          const target_words = params.product.split(" ");
          target_words.forEach((tw) => {
            if (tw.length <= 1) {
              return;
            }
            const clause = [
              "OR",
              ["product.name", "ilike", `%${tw}%`],
              ["product.description", "ilike", `%${tw}%`],
            ];
            domain.push(clause);
          });
        }
      }
    }

    if (domain) {
      const ctxView_ = { ...ctxView };
      ctxView_.pagination = domain;
      setCtxView(ctxView_);
      setDomain(domain);
      setViewTable(true);
      setViewTable2(viewTable2);
      setContext(ctxView_);
    }
  }

  async function handlePurchase() {
    if (!params.supplier) {
      return;
    }
    const { data } = await proxy.methodCall({
      model: "dash.app.purchase_requisition",
      method: "create_purchase",
      args: [params],
    });
    modalAttrs.value = {
      type: "warning",
      msg: data.msg,
      buttons: [],
    };
    openModal.value = true;
  }

  function updateRecords(field, value, recordId) {
    let value_ = value;
    const args = { id: recordId };
    if (field === "party") {
      value_ = value_.id;
    }
    args[field] = value_;
    proxy.saveQuery({ model: ctxView.model, storeRec: args });
  }

  async function handleClose() {
    openModal.value = false;
    await handleFilter({ ...params });
  }

  return (
    <QueryClientProvider client={customQuery}>
      <div className=" w-full m-4 relative">
        <div className="flex flex-col lg:flex-row justify-between flex-wrap gap-4">
          <div className="flex flex-wrap md:justify-start gap-4">
            <StdButton
              name={"requisition"}
              color="amber"
              size={"w-60 md:w-80"}
              onClick={handleButtonType}
              content="purchase_requisition.requisition"
            />
            <StdButton
              name={"suggested"}
              color="green"
              size={"w-60 md:w-80"}
              onClick={handleButtonType}
              content="purchase_requisition.suggested"
            />
            <StdButton
              style={"float-right"}
              name={"create_purchase"}
              color="blue"
              size={"w-60 md:w-80"}
              onClick={handlePurchase}
              content="purchase_requisition.create"
            />
          </div>
        </div>
        <FilterParams type={type} handleFilter={handleFilter} />
        {viewTable && (
          <QuickTable
            ctxView={ctxView}
            domain={domain}
            reload={true}
            updateRecords={updateRecords}
            level={"main"}
          />
        )}
        {viewTable2 && (
          <div className="pt-4">
            <Divider text="purchase_requisition.productsNotFound" />
            <TableData header={header} rows={dataRows} />
          </div>
        )}
        <Dialog
          openModal={openModal}
          buttons={modalAttrs.value.buttons}
          handleClose={handleClose}
          size={"w-1/3 h-1/3"}
        >
          <span className=" md:text-lg text-neutral-800">
            {modalAttrs.value.msg}
          </span>
        </Dialog>
      </div>
    </QueryClientProvider>
  );
}

export default PurchaseRequisition;
